import router from "../../router";
import constant from "../constant";

import {
  LOGIN,
  LOGOUT,
  AUTHORIZE,
  CHANGE_PASSWORD
} from "@/store/modules/mutation-types";

export default {
  state: {},
  getters: {},
  actions: {
    async [LOGIN]({ dispatch }, params) {
      const res = await dispatch("apiPost", {
        url: "/login",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      if (!res.data.error) {
        localStorage.setItem("access_token", res.data.access_token);
        localStorage.setItem("company_id", res.data.company_id);
        localStorage.setItem("department_id", res.data.department_id);
        localStorage.setItem("user_id", res.data.id);
        localStorage.setItem("user_name", res.data.user_name);
        localStorage.setItem("user_authority", res.data.authority);
      }
      return res.data;
    },
    [LOGOUT]({ commit }) {
      commit(LOGOUT);
    },
    async [AUTHORIZE]({ dispatch, commit }) {
      if (
        window.localStorage.getItem("keep_limit") &&
        parseInt(window.localStorage.getItem("keep_limit")) !== 0
      ) {
        let date = new Date();
        let now = date.getTime();

        if (now > parseInt(window.localStorage.getItem("keep_limit"))) {
          commit(LOGOUT);
        } else {
          let keepLimit = date.getTime() + constant.keepLimit;
          window.localStorage.setItem("keep_limit", keepLimit);
        }
      }
      const res = await dispatch("apiGet", {
        url: "/current_user_info"
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      if (res.data.error) {
        commit(LOGOUT);
      } else {
        localStorage.setItem("access_token", res.data.access_token);
        localStorage.setItem("company_id", res.data.company_id);
        localStorage.setItem("department_id", res.data.department_id);
        localStorage.setItem("user_id", res.data.id);
        localStorage.setItem("user_name", res.data.user_name);
        localStorage.setItem("user_authority", res.data.authority);
      }
    },
    async [CHANGE_PASSWORD]({ dispatch }, params) {
      let url = "/change_password";
      const res = await dispatch("apiPost", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    }
  },
  mutations: {
    [LOGOUT]() {
      window.localStorage.clear();
      window.sessionStorage.clear();
      router.push("/login");
    }
  }
};
